module.exports = __webpack_public_path__ + "static/media/bg4.ccb83d95.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/res/backgrounds/bg4.jpeg
// module id = 1091
// module chunks = 0